<!-- Breadcrumb for navigation -->
<app-breadcrumb 
	[title]="'merchant-info.common.merchantInfo' | translate" 
	[items]="['Dashboard' | translate]" 
	[active_item]="'merchant-info.common.merchantInfo' | translate">
</app-breadcrumb>

<div
	*ngIf="showSubscriptionExpiringBanner"
	class="subscription-expiring-banner alert alert-warning d-flex align-items-center justify-content-between flex-wrap gap-2 mx-3 mb-3"
	role="link"
	tabindex="0"
	(click)="goToInvoiceSubscriptions()"
	(keydown.enter)="goToInvoiceSubscriptions()"
	(keydown.space)="$event.preventDefault(); goToInvoiceSubscriptions()">
	<span class="flex-grow-1 subscription-expiring-banner__text">
		{{ 'merchant-info.subscriptionExpiring.message' | translate: { days: subscriptionExpiringDaysRemaining } }}
	</span>
	<button
		type="button"
		class="btn btn-link subscription-expiring-banner__close p-0 ms-2"
		[attr.aria-label]="'merchant-info.subscriptionExpiring.dismiss' | translate"
		(click)="dismissSubscriptionExpiringBanner($event)">
		<i class="fa fa-times" aria-hidden="true"></i>
	</button>
</div>

<p-confirmDialog></p-confirmDialog>

<!-- Container for merchant information -->
<div class="container-fluid basic_table" [hidden]="user_type == 100 || user_type == 101">
	<div class="row">
		<div class="col-sm-12">
			<div class="card">
				<div class="card-header d-flex justify-content-between">
					<h5 style="color: grey;">{{ 'merchant-info.common.merchantInfo' | translate }}</h5>
					<div>
						<!-- Button to add a new merchant -->
							<button 
							[hidden]="user_type == 100" 
							class="btn" 
							style="background-color: #141414; color: #fff;" 
							(click)="openXl(content)">
							<i class="fa fa-plus-circle mx-1"></i>
							{{ 'merchant-info.modal.addMerchant' | translate }}
						</button>
						<!-- Button to refresh merchant information -->
							<button 
							class="btn mx-1 btn-outline-warning" 
							(click)="getAllMerchantInfo()">
							<i class="fa fa-refresh mx-1"></i> 
							{{ 'merchant-info.common.refresh' | translate }}
						</button>
					</div>
				</div>

				<div class="row">
					<div class="col-sm-5">
						<div class="form-group search m-3">
							<label for="seaarch" class="ml-2" style="color: grey;">
								{{ 'merchant-info.common.search' | translate }}
							</label>
							<input 
								class="form-control w-100" 
								type="text" 
								name="search" 
								[ngModelOptions]="{standalone: true}" 
								id="seaarch" 
								[(ngModel)]="term" 
								placeholder="{{ 'merchant-info.common.search' | translate }}" />
						</div>
					</div>
				</div>

				<div class="card-block row">
					<div class="col-12">
						<div class="table-responsive">
							<table class="table table-hover align-middle text-center merchant-table mb-0">
								<thead class="merchant-table__head">
									<tr>
										<th scope="col" class="merchant-col-num">#</th>
										<th scope="col" class="text-start">{{ 'merchant-info.columns.merchantName' | translate }}</th>
										<th scope="col" class="d-none d-md-table-cell">{{ 'merchant-info.columns.merchantAddress' | translate }}</th>
										<th scope="col">{{ 'merchant-info.columns.idNumber' | translate }}</th>
										<th scope="col" class="d-none d-lg-table-cell">{{ 'merchant-info.columns.merchantStatus' | translate }}</th>
										<th scope="col" class="d-none d-lg-table-cell">{{ 'merchant-info.columns.createdDate' | translate }}</th>
										<th scope="col" class="d-none d-lg-table-cell">{{ 'merchant-info.columns.createdBy' | translate }}</th>
										<th scope="col">{{ 'merchant-info.columns.subscriptionStartDate' | translate }}</th>
										<th scope="col">{{ 'merchant-info.columns.subscriptionEndDate' | translate }}</th>
										<th scope="col">{{ 'merchant-info.columns.subscriptionSubStatus' | translate }}</th>
										<th scope="col" class="d-none d-xl-table-cell">{{ 'merchant-info.columns.status' | translate }}</th>
										<th scope="col" class="d-none d-xl-table-cell">{{ 'merchant-info.columns.merchantUsers' | translate }}</th>
										<th scope="col">{{ 'merchant-info.columns.view' | translate }}</th>
										<th scope="col">{{ 'merchant-info.columns.update' | translate }}</th>
									</tr>
								</thead>
								<tbody>
									<tr 
										*ngFor="let item of merchantInfoData | paginate: {itemsPerPage:100, currentPage:p } | filter:term; let i = index"
										class="merchant-table__row">
										<td class="merchant-col-num text-secondary fw-medium">{{ i + 1 }}</td>
										<td class="text-start fw-medium">
											{{ (item.merchant_name_he || item.merchant_name_en || item.merchant_name_ar)?.substring(0, 25) }}
										</td>
										<td class="d-none d-md-table-cell small text-secondary">{{ item.merchant_address?.substring(0, 22) }}</td>
										<td class="small">{{ item.id_number }}</td>

										<!-- Merchant status -->
										<td class="d-none d-lg-table-cell">
											<span
												class="badge rounded-pill merchant-status-badge"
												[class.merchant-status--active]="item.lookupDetailsStatus?.status === 1"
												[class.merchant-status--inactive]="item.lookupDetailsStatus?.status === 59">
												{{ item.lookupDetailsStatus?.['lookupDetail' + curentLang.charAt(0).toUpperCase() + curentLang.slice(1) + 'Name'] }}
											</span>
										</td>

										<td class="d-none d-lg-table-cell small text-nowrap">{{ item.createdDate | date: 'dd/MM/yyyy' }}</td>

										<td class="d-none d-lg-table-cell small text-start">
											<ng-container *ngIf="item.createdBy?.user_name; else noCreatedBy">
												{{ item.createdBy.user_name }}
											</ng-container>
											<ng-template #noCreatedBy>
												<span class="text-muted">—</span>
											</ng-template>
										</td>

										<!-- Subscription start date -->
										<td class="text-nowrap small">
											<ng-container *ngIf="item.invoiceSubscriptions?.[0]?.start_date; else noSubDate">
												{{ item.invoiceSubscriptions[0].start_date | date: 'dd/MM/yyyy' }}
											</ng-container>
											<ng-template #noSubDate>
												<span class="text-muted">—</span>
											</ng-template>
										</td>

										<!-- Subscription end date -->
										<td class="text-nowrap small">
											<ng-container *ngIf="item.invoiceSubscriptions?.[0]?.end_date; else noEndDate">
												{{ item.invoiceSubscriptions[0].end_date | date: 'dd/MM/yyyy' }}
											</ng-container>
											<ng-template #noEndDate>
												<span class="text-muted">—</span>
											</ng-template>
										</td>

										<!-- Subscription status pill -->
										<td>
											<ng-container *ngIf="item.invoiceSubscriptions?.[0]?.status as subStatus; else noSub">
												<span
													class="badge rounded-pill merchant-sub-badge"
													[class.merchant-sub--active]="subStatus === 'active'"
													[class.merchant-sub--cancelled]="subStatus === 'cancelled'"
													[class.merchant-sub--expired]="subStatus === 'expired'">
													{{ ('merchant-info.subscriptionStatuses.' + subStatus) | translate }}
												</span>
											</ng-container>
											<ng-template #noSub>
												<span class="text-muted small">—</span>
											</ng-template>
										</td>

										<!-- Toggle status -->
										<td class="d-none d-xl-table-cell">
											<button 
												[disabled]="user_type == 100 || user_type == 101" 
												*ngIf="item.merchant_status==1" 
												class="btn btn-link p-0" 
												(click)="changeStatus(item?.merchant_id, item.merchant_status)">
												<i class="fa fa-toggle-on fa-lg" style="color: #213FA6;"></i>
											</button>
											<button 
												[disabled]="user_type == 100 || user_type == 101" 
												*ngIf="item.merchant_status==59" 
												class="btn btn-link p-0"
												(click)="changeStatus(item?.merchant_id, item.merchant_status)">
												<i class="fa fa-toggle-off fa-lg" style="color: #FC4438;"></i>
											</button>
										</td>

										<!-- Merchant users -->
										<td class="d-none d-xl-table-cell">
											<a routerLink="/dashboard/all-merchant-users/{{item.merchant_id}}" class="btn btn-link p-0">
												<i class="fa fa-user-circle-o fa-lg text-dark"></i>
											</a>
										</td>

										<!-- View -->
										<td>
											<a routerLink="/dashboard/view-merchant/{{item.merchant_id}}" class="btn btn-link p-0">
												<i class="fa fa-eye fa-lg text-secondary"></i>
											</a>
										</td>

										<!-- Edit -->
										<td>
											<a routerLink="/dashboard/update-merchant/{{item.merchant_id}}" class="btn btn-link p-0">
												<i class="fa fa-edit fa-lg text-success"></i>
											</a>
										</td>
									</tr>
								</tbody>
							</table>
							<pagination-controls 
								(pageChange)="p = $event" 
								class="m-auto my-3 current">
							</pagination-controls>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<!-- Hidden div for account statement PDF rendering (template-based) -->
<div id="account-statement-pdf-content" style="display:none;">
	<div *ngIf="accountStatementPdfData">
		<html lang="he" dir="rtl">

		<head>
			<meta charset="UTF-8" />
			<meta name="viewport" content="width=device-width, initial-scale=1.0" />
			<title>Invoice Summary</title>
			<style>
				body {
					font-family: Arial, sans-serif;
					margin: 20px;
				}

				h2 {
					text-align: center;
				}

				table {
					width: 100%;
					border-collapse: collapse;
					margin-top: 20px;
				}

				th,
				td {
					border: 1px solid #ddd;
					padding: 8px;
					text-align: center;
				}

				th {
					background-color: #f4f4f4;
				}
			</style>
		</head>

		<body>
			<h2>{{ accountStatementPdfData.invoice_date }}</h2>
			<div style="text-align: right; font-family: Arial, sans-serif;">
				<div style="text-align: left;"></div>
				<h3 style="margin: 0;">{{ accountStatementPdfData.company_name }}</h3>
				<p style="margin: 0;">
					{{ accountStatementPdfData.company_address_str }} - {{ accountStatementPdfData.company_phone }}
				</p>
				<p style="margin: 0;">
					<strong>{{ 'merchant-info.common.customerName' | translate }}:</strong> {{ accountStatementPdfData.customer_name }}
					<span *ngIf="accountStatementPdfData.customer_vat_number">
						| <strong>{{ 'addInvoiceWithReceipt.routes.addInvoiceWithReceipt.customerVatNumber' | translate }}:</strong> {{
						accountStatementPdfData.customer_vat_number }}
					</span>
					<span *ngIf="accountStatementPdfData.customer_vat_tax">
						| <strong>{{ 'addInvoiceWithReceipt.routes.addInvoiceWithReceipt.customerVatTax' | translate }}:</strong> {{
						accountStatementPdfData.customer_vat_tax }}
					</span>
				</p>
				<p style="margin: 0;">
					<strong>{{ 'merchant-info.common.document' | translate }}:</strong> {{ accountStatementPdfData.document_number }}
					<span *ngIf="accountStatementPdfData.total_amount">
						| <strong>{{ 'addInvoiceWithReceipt.routes.addInvoiceWithReceipt.totalAmount' | translate }}:</strong> {{
						accountStatementPdfData.total_amount }}
					</span>
				</p>
				<hr />
				<h3 style="margin: 0; text-align:center">
					كشف حساب - : <strong>{{ accountStatementPdfData.customer_name }}</strong>
				</h3>
			</div>
			<table>
				<thead>
					<tr>
						<th>{{ 'merchant-info.common.date' | translate }}</th>
						<th>{{ 'merchant-info.common.document' | translate }}</th>
						<th>{{ 'merchant-info.common.documentType' | translate }}</th>
						<th>{{ 'merchant-info.common.debit' | translate }}</th>
						<th>{{ 'merchant-info.common.credit' | translate }}</th>
						<th>{{ 'merchant-info.common.runningBalance' | translate }}</th>
						<th>{{ 'merchant-info.common.notes' | translate }}</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td colspan="5"></td>
						<td><strong>{{ accountStatementPdfData.initial_value }}</strong></td>
						<td></td>
					</tr>
					<tr *ngFor="let row of accountStatementPdfData.formattedInvoices">
						<td>{{ row.invoice_date }}</td>
						<td>{{ row.document_number }}</td>
						<td>{{ row.invoice_type }}</td>
						<td>{{ row.debit }}</td>
						<td>{{ row.credit }}</td>
						<td>{{ row.cumulative_total }}</td>
						<td>{{ row.invoice_note }}</td>
					</tr>
					<tr>
						<td colspan="3"></td>
						<td><strong>{{ accountStatementPdfData.total_debit }}</strong></td>
						<td><strong>{{ accountStatementPdfData.total_credit }}</strong></td>
						<td><strong>{{ accountStatementPdfData.running_total }}</strong></td>
						<td></td>
						<td></td>
					</tr>
				</tbody>
			</table>
		</body>

		</html>
	</div>
</div>

<!-- Modal for adding a new merchant -->
<ng-template #content let-modal>
	<div class="modal-header d-flex justify-content-between">
		<h6 class="modal-title" style="color: grey;">
			{{ 'merchant-info.modal.addMerchantTitle' | translate }}
		</h6>
		<button 
			type="button" 
			class="close btn-close" 
			style="color: grey;" 
			aria-label="Close" 
			(click)="modal.dismiss('Cross click')">
			 
		</button>
	</div>
	<div class="modal-body pt-2 pb-3">
		<div class="container-fluid px-2">
			<div class="edit-profile">
				<form 
					class="theme-form w-100" 
					[formGroup]="merchantForm" 
					novalidate 
					[ngClass]="{ 'was-validated': validate }">
						<div class="row g-3">
								<!-- Input for merchant name -->
								<div class="col-lg-6 col-md-6 col-sm-12">
									<label class="col-form-label pt-0" style="color: #141414;">
										{{ 'Register.name' | translate }}
										<span class="text-danger">*</span>
									</label>
									<input 
										class="form-control" 
										type="text" 
										maxlength="20" 
										required="" 
										onlyAlphabets 
										placeholder="{{ 'Register.name' | translate }}" 
										formControlName="user_name">
									<!-- Error messages for merchant name -->
									<div 
										*ngIf="merchantForm.get('user_name')?.errors != null && merchantForm.get('user_name')?.touched" 
										class="alert text-danger my-1">
										<p *ngIf="merchantForm.get('user_name')?.errors?.required" class="my-1 text-danger">
											{{ 'Register.nameuserRequierd' | translate }}
										</p>
										<p *ngIf="merchantForm.get('user_name')?.errors?.minlength" class="my-1 text-danger">
											{{ 'Register.error1' | translate }}
										</p>
										<p *ngIf="merchantForm.get('user_name')?.errors?.maxlength" class="my-1 text-danger">
											{{ 'Register.error2' | translate }}
										</p>
									</div>
									<div class="invalid-feedback text-danger">
										{{ 'Register.enterUserName' | translate }}
									</div>
								</div>
								<div class="col-lg-6 col-md-6 col-sm-12">
									<label class="col-form-label pt-0" style="color: #141414;">
										{{ 'Register.phone' | translate }}
										<span class="text-danger">*</span>
									</label>
									<div class="input-group">
										<span style="color: #141414;" class="input-group-text">+972</span>
										<input 
											class="form-control" 
											type="text" 
											maxlength="10" 
											required="" 
											onlyAlphabets 
											placeholder="{{ 'Register.phone' | translate }}" 
											formControlName="phone_number">
									</div>
									<div 
										*ngIf="merchantForm.get('phone_number')?.errors != null && merchantForm.get('phone_number')?.touched" 
										class="alert text-danger my-1">
										<p *ngIf="merchantForm.get('phone_number')?.errors?.required" class="my-1 text-danger">
											{{ 'Register.phoneRequierd' | translate }}
										</p>
										<p *ngIf="merchantForm.get('phone_number')?.errors?.invalidMobilePrefix" class="my-1 text-danger">
											{{ merchantForm.get('phone_number')?.errors?.invalidMobilePrefix.message }}
										</p>
										<p *ngIf="merchantForm.get('phone_number')?.errors?.invalidPhoneNumber" class="my-1 text-danger">
											{{ merchantForm.get('phone_number')?.errors?.invalidPhoneNumber.message }}
										</p>
									</div>
									<div class="invalid-feedback text-danger">
										{{ 'Register.enterPhoneNumber' | translate }}
									</div>
								</div>
						</div>
						<div class="row g-3 mt-1">
							<div class="col-lg-4 col-md-6 col-sm-12">
								<div class="form-group">
									<label class="col-form-label" style="color: #141414;">
										{{ 'Register.merchant_nameAr' | translate }}
									</label>
									<input 
										class="form-control" 
										type="text" 
										maxlength="80" 
										placeholder="{{ 'Register.merchant_nameAr' | translate }}" 
										formControlName="merchant_name_ar">
									<div 
										*ngIf="merchantForm.get('merchant_name_ar')?.errors != null && merchantForm.get('merchant_name_ar')?.touched" 
										class="alert text-danger my-1">
										<p *ngIf="merchantForm.get('merchant_name_ar')?.errors?.minlength" class="my-1 text-danger">
											{{ 'Register.error1' | translate }}
										</p>
										<p *ngIf="merchantForm.get('merchant_name_ar')?.errors?.maxlength" class="my-1 text-danger">
											{{ 'Register.error2' | translate }}
										</p>
									</div>
								</div>
							</div>
							<div class="col-lg-4 col-md-6 col-sm-12">
								<div class="form-group">
									<label class="col-form-label" style="color: #141414;">
										{{ 'Register.merchant_nameEn' | translate }}
									</label>
									<input 
										class="form-control" 
										type="text" 
										maxlength="80" 
										placeholder="{{ 'Register.merchant_nameEn' | translate }}" 
										formControlName="merchant_name_en">
									<div 
										*ngIf="merchantForm.get('merchant_name_en')?.errors != null && merchantForm.get('merchant_name_en')?.touched" 
										class="alert text-danger my-1">
										<p *ngIf="merchantForm.get('merchant_name_en')?.errors?.minlength" class="my-1 text-danger">
											{{ 'Register.error1' | translate }}
										</p>
										<p *ngIf="merchantForm.get('merchant_name_en')?.errors?.maxlength" class="my-1 text-danger">
											{{ 'Register.error2' | translate }}
										</p>
									</div>
								</div>
							</div>
							<div class="col-lg-4 col-md-6 col-sm-12">
								<div class="form-group">
									<label class="col-form-label" style="color: #141414;">
										{{ 'Register.merchant_nameHe' | translate }}
										<span class="text-danger">*</span>
									</label>
									<input 
										class="form-control" 
										type="text" 
										maxlength="80" 
										required="" 
										onlyAlphabets 
										placeholder="{{ 'Register.merchant_nameHe' | translate }}" 
										formControlName="merchant_name_he">
									<div 
										*ngIf="merchantForm.get('merchant_name_he')?.errors != null && merchantForm.get('merchant_name_he')?.touched" 
										class="alert text-danger my-1">
										<p *ngIf="merchantForm.get('merchant_name_he')?.errors?.required" class="my-1 text-danger">
											{{ 'Register.merchant_name_ar' | translate }}
										</p>
										<p *ngIf="merchantForm.get('merchant_name_he')?.errors?.minlength" class="my-1 text-danger">
											{{ 'Register.error1' | translate }}
										</p>
										<p *ngIf="merchantForm.get('merchant_name_he')?.errors?.maxlength" class="my-1 text-danger">
											{{ 'Register.error2' | translate }}
										</p>
									</div>
									<div class="invalid-feedback text-danger">
										{{ 'Register.enterMerchantName' | translate }}
									</div>
								</div>
							</div>
							<div class="col-lg-4 col-md-6 col-sm-12 mb-2">
								<div class="form-group">
									<label class="col-form-label" style="color: #141414;">
										{{ 'Register.merchantadress' | translate }}
										<span class="text-danger">*</span>
									</label>
									<input 
										class="form-control" 
										type="text" 
										required="" 
										onlyAlphabets 
										maxlength="400" 
										placeholder="{{ 'Register.merchantadress' | translate }}" 
										formControlName="merchant_address">
									<div 
										*ngIf="merchantForm.get('merchant_address')?.errors != null && merchantForm.get('merchant_address')?.touched" 
										class="alert text-danger my-1">
										<p *ngIf="merchantForm.get('merchant_address')?.errors?.required" class="my-1 text-danger">
											{{ 'Register.merchant_address' | translate }}
										</p>
										<p *ngIf="merchantForm.get('merchant_name_he')?.errors?.maxlength" class="my-1 text-danger">
											{{ 'Register.error3' | translate }}
										</p>
									</div>
									<div class="invalid-feedback text-danger">
										{{ 'Register.enterMerchantAddress' | translate }}
									</div>
								</div>
							</div>
							<div class="col-lg-4 col-md-6 col-sm-12 mb-2">
								<div class="form-group">
									<label class="col-form-label" style="color: #141414;">
										{{ 'Register.idNumber' | translate }}
									</label>
									<input 
										class="form-control" 
										type="number" 
										maxlength="20" 
										placeholder="{{ 'Register.idNumber' | translate }}" 
										formControlName="id_number">
									<div 
										*ngIf="merchantForm.get('id_number')?.errors != null && merchantForm.get('id_number')?.touched" 
										class="alert text-danger my-1">
										<p *ngIf="merchantForm.get('id_number')?.errors?.required" class="my-1 text-danger">
											{{ 'Register.id_numberreq' | translate }}
										</p>
									</div>
								</div>
							</div>
							<div class="col-lg-4 col-md-6 col-sm-12 mb-2">
								<div class="form-group position-relative">
									<label class="col-form-label" style="color: #141414;">
										{{ 'Register.password' | translate }}
										<span class="text-danger">*</span>
									</label>
									<input 
										class="form-control" 
										[type]="show ? 'text' : 'password'" 
										name="login[password]" 
										formControlName="password" 
										required="" 
										placeholder="*********" 
										(input)="handlePasswordValidation(merchantForm)">
									<div 
										*ngIf="merchantForm.get('password')?.errors && merchantForm.get('password')?.touched" 
										class="alert text-danger my-1">
										<p *ngIf="merchantForm.get('password')?.errors?.required" class="my-1 text-danger">
											{{ 'Login.passwordRequired' | translate }}
										</p>
										<p *ngIf="merchantForm.get('password')?.errors?.minlength" class="my-1 text-danger">
											{{ 'Login.passwordMinLength' | translate }}
										</p>
										<p *ngIf="merchantForm.get('password')?.errors?.maxlength" class="my-1 text-danger">
											{{ 'Login.passwordMaxLength' | translate }}
										</p>
										<p *ngIf="merchantForm.get('password')?.errors?.uppercase" class="my-1 text-danger">
											{{ 'Login.passwordUppercase' | translate }}
										</p>
										<p *ngIf="merchantForm.get('password')?.errors?.specialChar" class="my-1 text-danger">
											{{ 'Login.passwordSpecialChar' | translate }}
										</p>
									</div>
									<div 
										class="show-hide" 
										[ngClass]="{'rtl': curentLang === 'ar' || curentLang === 'he'}" 
										(click)="showPassword()">
										<i class="fa" [ngClass]="show ? 'fa-eye-slash' : 'fa-eye'"></i>
									</div>
								</div>
							</div>
						</div>
						<!-- Modal footer with confirm and back buttons -->
						<div class="modal-footer border-top flex-wrap gap-2 justify-content-end mt-3 pt-3 px-0 pb-0">
							<button 
								type="button" 
								class="btn btn-sm btn-danger" 
								(click)="modal.close('Close click')">
								{{ 'Register.back' | translate }}
								<i class="fa fa-rotate-left mx-1"></i>
							</button>
							<button 
								type="button" 
								class="btn btn-sm" 
								style="background-color: #141414; color: #fff;" 
								[disabled]="merchantForm.get('password')?.invalid" 
								(click)="submitMerchantForm(merchantForm)">
								{{ 'Register.confirm' | translate }}
								<i class="fa fa-check-circle mx-1" style="color: #fff;"></i>
							</button>
						</div>
					</form>
			</div>
		</div>
	</div>
</ng-template>

<div class="container-fluid" [hidden]="user_type == 200 || user_type == 201 || user_type == 100 || user_type == 101">
	<div class="user-profile">
		<div class="row">
			<div class="col-sm-12">
				<div class="card hovercard text-center">
					<div class="user-image mt-5">
						<div class="avatar">
							<img src="../../../assets/icons/apple-touch-icon.png" alt="">
						</div>
					</div>
					<div class="info" *ngFor="let item of merchantInfoData">
						<div class="row">
							<div class="col-6 col-md-4 order-sm-0 order-xl-1 m-auto" style="color: #141414;">
								<div class="title" style="font-size: 14px;">
									<h6 style="font-size: 14px;">
										{{ 'merchant-info.common.phoneNumber' | translate }} {{ MerchantPhone || ('merchant-info.common.notAvailable' | translate) }}
									</h6>
									<h6 style="font-size: 14px;">
										{{ item['merchant_name_' + curentLang]?.substring(0, 20) || ('merchant-info.common.notAvailable' | translate) }}
									</h6>
									<label class="form-label px-1" style="color: grey;">
										{{ 'merchant-info.common.companyName' | translate }}
									</label>
									<div class="px-1" style="text-align: center;">
										<span *ngIf="getSelectedCompanyName()" style="color: #141414; font-size: 14px;">
											{{ getSelectedCompanyName() }}
										</span>
										<span *ngIf="!getSelectedCompanyName()" style="color: #999; font-size: 14px;">
											{{ 'merchant-info.common.notAvailable' | translate }}
										</span>
									</div>
									<h6 *ngIf="item.createdBy?.user_name" class="mt-2 mb-0" style="font-size: 13px; color: grey;">
										{{ 'merchant-info.columns.createdBy' | translate }}:
										<span style="color: #141414;">{{ item.createdBy.user_name }}</span>
									</h6>
								</div>
							</div>
						</div>
						<hr />
						<div class="follow">
							<div class="row d-flex justify-content-between">
								<div class="col-4 text-md-end border-end" style="color: #141414;">
									<div class="follow-num"></div>
									<span 
										routerLink="/dashboard/expenses" 
										class="small-text" 
										style="color: rgb(0, 0, 0); cursor: pointer;">
										<i 
											class="fa fa-folder" 
											style="color: rgb(0, 0, 0); font-size: 10px; cursor: pointer;" 
											title="{{ 'menu.expenses' | translate }}">
										</i>
										{{ 'menu.expenses' | translate }}
									</span>
								</div>
								<div class="col-4 text-md-center" style="color: #141414;">
									<div class="follow-num counter"></div>
									<span 
										routerLink="/dashboard/view-merchant/{{item.merchant_id}}" 
										class="small-text" 
										style="color: rgb(0, 0, 0); cursor: pointer;">
										<i 
											class="fa fa-eye" 
											style="color: rgb(0, 0, 0); font-size: 10px; cursor: pointer;" 
											title="{{ 'merchant-info.common.viewInfo' | translate }}" 
											routerLink="/dashboard/view-merchant/{{item.merchant_id}}">
										</i>
										{{ 'merchant-info.common.viewInfo' | translate }}
									</span>
								</div>
								<div class="col-4 text-md-start" style="color: #141414;">
									<div class="follow-num counter"></div>
									<span 
										routerLink="/dashboard/update-merchant/{{item.merchant_id}}" 
										class="small-text" 
										style="color: rgb(0, 0, 0); cursor: pointer;">
										<i 
											class="fa fa-edit" 
											style="color: rgb(0, 0, 0); font-size: 10px; cursor: pointer;" 
											title="{{ 'merchant-info.common.updateInfo' | translate }}" 
											routerLink="/dashboard/update-merchant/{{item.merchant_id}}">
										</i>
										{{ 'merchant-info.common.updateInfo' | translate }}
									</span>
								</div>
							</div>
							<hr style="color: #141414;" />
							<div class="row">
							<div 
								class="col-6 col-sm-6 col-xl-4" 
								style="cursor: pointer;" 
								routerLink="/dashboard/invoices-v2">
								<div class="ribbon-wrapper card">
									<div class="card-body text-center text-white">
										<i 
											class="icofont icofont-file-text" 
											style="color:#fff; font-size: 35px; cursor: pointer;">
										</i>
										<p>{{ 'merchant-info.common.documents' | translate }}</p>
									</div>
								</div>
							</div>
							<div 
								class="col-6 col-sm-6 col-xl-4" 
								style="cursor: pointer;" 
								(click)="openXl2(content2)">
								<div class="ribbon-wrapper card">
									<div class="card-body text-center text-white">
										<i 
											class="fa fa-file-text" 
											style="color:#fff; font-size: 35px; cursor: pointer;">
										</i>
										<p>{{ 'merchant-info.common.invoices' | translate }}</p>
									</div>
								</div>
							</div>
								<div 
									class="col-6 col-sm-6 col-xl-4" 
									style="cursor: pointer;" 
									routerLink="/dashboard/expenses">
									<div class="ribbon-wrapper card">
										<div class="card-body text-center text-white">
											<i 
												class="fa fa-folder" 
												style="color:#fff; font-size: 35px; cursor: pointer;">
											</i>
											<p>{{ 'menu.expenses' | translate }}</p>
										</div>
									</div>
								</div>
								<div 
									class="col-6 col-sm-6 col-xl-4" 
									style="cursor: pointer;" 
									(click)="showReportOptions()">
									<div class="ribbon-wrapper card">
										<div class="card-body text-center text-white">
											<i 
												class="fa fa-file" 
												style="color:#fff; font-size: 35px; cursor: pointer;">
											</i>
											<p>{{ 'merchant-info.common.reports' | translate }}</p>
										</div>
									</div>
								</div>
								<div 
									class="col-6 col-sm-6 col-xl-4" 
									style="cursor: pointer;" 
									routerLink="/dashboard/companies">
									<div class="ribbon-wrapper card">
										<div class="card-body text-center text-white">
											<i 
												class="fa fa-building-o" 
												style="color:#fff; font-size: 35px; cursor: pointer;">
											</i>
											<p>{{ 'merchant-info.common.companies' | translate }}</p>
										</div>
									</div>
								</div>
								<div 
									class="col-6 col-sm-6 col-xl-4" 
									style="cursor: pointer;" 
									routerLink="/dashboard/products">
									<div class="ribbon-wrapper card">
										<div class="card-body text-center text-white">
											<i 
												class="fa fa-shopping-cart" 
												style="color:#fff; font-size: 35px; cursor: pointer;">
											</i>
											<p>{{ 'merchant-info.common.products' | translate }}</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<!-- Have Questions Button - Minimal and Professional -->
<div class="container-fluid" [hidden]="user_type == 200 || user_type == 201 || user_type == 100 || user_type == 101">
	<div class="row mt-3 mb-3">
		<div class="col-12 d-flex justify-content-center">
			<a routerLink="/support" class="text-decoration-none">
				<button class="btn btn-outline-primary d-flex align-items-center gap-2" style="padding: 10px 20px; border-radius: 6px; font-weight: 500; border-width: 1px; transition: all 0.3s ease;">
					<i class="fa fa-question-circle" style="font-size: 1rem;"></i>
					<span>{{ curentLang === 'en' ? 'Have Questions?' : (curentLang === 'ar' ? 'لديك أسئلة؟' : 'יש לך שאלות?') }}</span>
				</button>
			</a>
		</div>
	</div>
</div>

<!-- Modal for uploading profile image -->
<ng-template #uploadData let-modal>
	<div class="modal-header">
		<h6 class="modal-title" style="color: grey;">
			{{ 'merchant-info.modal.updateProfileImage' | translate }}
		</h6>
		<button 
			type="button" 
			class="close btn-close" 
			style="color: grey;" 
			aria-label="Close" 
			(click)="modal.dismiss('Cross click')">
			 
		</button>
	</div>
	<div class="modal-body my-2">
		<div class="product-image text-center">
			<img *ngIf="currentImageUrl" [src]="currentImageUrl" alt="" class="my-2">
			<input 
				type="file" 
				class="form-control form-control-sm" 
				(change)="onFileChanged($event)" 
				[accept]="'image/*'">
		</div>
	</div>
	<div class="modal-footer">
		<button 
			type="button" 
			class="btn btn-sm m-auto mt-2" 
			style="background-color: #141414; color: #fff;" 
			(click)="uploadFile()">
			{{ 'merchant-info.common.confirm' | translate }}
			<i class="fa fa-check-circle mx-1" style="color: #fff;"></i>
		</button>
		<button 
			type="button" 
			class="btn btn-sm m-auto mt-2 btn-danger" 
			(click)="modal.close('Close click')">
			{{ 'merchant-info.common.back' | translate }}
			<i class="fa fa-rotate-left mx-1"></i>
		</button>
	</div>
</ng-template>

<!-- Modal for selecting invoice types -->
<ng-template #content2 let-modal>
	<div class="modal-header d-flex justify-content-between">
		<h6 class="modal-title" style="color: grey;">
			{{ 'merchant-info.modal.invoicesTypes' | translate }}
		</h6>
		<button 
			type="button" 
			class="close btn-close" 
			style="color: grey;" 
			aria-label="Close" 
			(click)="modal.dismiss('Cross click')">
			 
		</button>
	</div>
	<div class="modal-body">
		<div class="container-fluid">
			<div class="edit-profile">
				<div class="row d-flex justify-content-between">
				<div class="content" *ngIf="isInvoiceTypeAllowed('/dashboard/add-invoice')">
					<p 
						[routerLink]="['/dashboard/invoices-v2/create']" [queryParams]="{type: 305}"
						style="cursor: pointer;" 
						(click)="modal.close('Close click')">
						<i 
							class="fa fa-plus mx-1" 
							style="color: #141414; font-size: 14px;">
						</i>
						{{ 'merchant-info.documentTypes.taxInvoice' | translate }}
					</p>
					<hr style="color: #141414; border: solid 1px;">
				</div>
				<div class="content" *ngIf="isInvoiceTypeAllowed('/dashboard/add-receipts')">
					<p 
						[routerLink]="['/dashboard/invoices-v2/create']" [queryParams]="{type: 400}"
						style="cursor: pointer;" 
						(click)="modal.close('Close click')">
						<i 
							class="fa fa-plus mx-1" 
							style="color: #141414; font-size: 14px;">
						</i>
						{{ 'merchant-info.documentTypes.receipt' | translate }}
					</p>
					<hr style="color: #141414; border: solid 1px;">
				</div>
				<div class="content" *ngIf="isInvoiceTypeAllowed('/dashboard/add-invoice-with-receipt')">
					<p 
						[routerLink]="['/dashboard/invoices-v2/create']" [queryParams]="{type: 320}"
						style="cursor: pointer;" 
						(click)="modal.close('Close click')">
						<i 
							class="fa fa-plus mx-1" 
							style="color: #141414; font-size: 14px;">
						</i>
						{{ 'merchant-info.documentTypes.invoiceAndReceipt' | translate }}
					</p>
					<hr style="color: #141414; border: solid 1px;">
				</div>
				<div class="content" *ngIf="isInvoiceTypeAllowed('/dashboard/add-finaical-request')">
					<p 
						[routerLink]="['/dashboard/invoices-v2/create']" [queryParams]="{type: 332}"
						style="cursor: pointer;" 
						(click)="modal.close('Close click')">
						<i 
							class="fa fa-plus mx-1" 
							style="color: #141414; font-size: 14px;">
						</i>
						{{ 'merchant-info.documentTypes.financialRequest' | translate }}
					</p>
					<hr style="color: #141414; border: solid 1px;">
				</div>
				<div class="content" *ngIf="isInvoiceTypeAllowed('/dashboard/add-reverce-invoice')">
					<p 
						[routerLink]="['/dashboard/invoices-v2/create']" [queryParams]="{type: 330}"
						style="cursor: pointer;" 
						(click)="modal.close('Close click')">
						<i 
							class="fa fa-plus mx-1" 
							style="color: #141414; font-size: 14px;">
						</i>
						{{ 'merchant-info.documentTypes.reverseInvoice' | translate }}
					</p>
					<hr style="color: #141414; border: solid 1px;">
				</div>
				<div class="content" *ngIf="isInvoiceTypeAllowed('/dashboard/add-mission')">
					<p 
						[routerLink]="['/dashboard/invoices-v2/create']" [queryParams]="{type: 200}"
						style="cursor: pointer;" 
						(click)="modal.close('Close click')">
						<i 
							class="fa fa-plus mx-1" 
							style="color: #141414; font-size: 14px;">
						</i>
						{{ 'merchant-info.documentTypes.mission' | translate }}
					</p>
					<hr style="color: #141414; border: solid 1px;">
				</div>
				<div class="content" *ngIf="isInvoiceTypeAllowed('/dashboard/add-offer-price')">
					<p 
						[routerLink]="['/dashboard/invoices-v2/create']" [queryParams]="{type: 0}"
						style="cursor: pointer;" 
						(click)="modal.close('Close click')">
						<i 
							class="fa fa-plus mx-1" 
							style="color: #141414; font-size: 14px;">
						</i>
						{{ 'merchant-info.documentTypes.offerPrice' | translate }}
					</p>
					<hr style="color: #141414; border: solid 1px;">
				</div>
				<div class="content" *ngIf="isInvoiceTypeAllowed('/dashboard/add-order')">
					<p 
						[routerLink]="['/dashboard/invoices-v2/create']" [queryParams]="{type: 100}"
						style="cursor: pointer;" 
						(click)="modal.close('Close click')">
						<i 
							class="fa fa-plus mx-1" 
							style="color: #141414; font-size: 14px;">
						</i>
						{{ 'merchant-info.documentTypes.order' | translate }}
						</p>
						<hr style="color: #141414; border: solid 1px;">
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="modal-footer d-flex justify-content-between">
		<div></div>
		<button 
			routerLink="/dashboard/merchant-info" 
			type="button" 
			class="btn btn-sm ml-auto btn-danger" 
			(click)="modal.close('Close click')">
			{{ 'merchant-info.common.back' | translate }}
			<i class="fa fa-rotate-left mx-1"></i>
		</button>
	</div>
</ng-template>

<!-- Modal for displaying user information -->
<ng-template #content3 let-modal>
	<div class="modal-header d-flex justify-content-between">
		<h6 class="modal-title" style="color: grey;">
			{{ 'merchant-info.modal.usersInfo' | translate }}
		</h6>
		<button 
			type="button" 
			class="close btn-close" 
			style="color: grey;" 
			aria-label="Close" 
			(click)="modal.dismiss('Cross click')">
			 
		</button>
	</div>
	<div class="modal-body">
		<app-users [isInsideModal]="true"></app-users>
	</div>
	<div class="modal-footer d-flex justify-content-between">
		<div></div>
		<button 
			routerLink="/dashboard/merchant-info" 
			type="button" 
			class="btn btn-sm ml-auto btn-danger" 
			(click)="modal.close('Cross click')">
			{{ 'merchant-info.common.back' | translate }}
			<i class="fa fa-rotate-left mx-1"></i>
		</button>
	</div>
</ng-template>

<!-- Modal for displaying document information -->
<ng-template #content10 let-modal>
	<div class="modal-header d-flex justify-content-between">
		<h6 class="modal-title" style="color: grey;">
			{{ 'merchant-info.modal.documentsInfo' | translate }}
		</h6>
		<button 
			type="button" 
			class="close btn-close" 
			style="color: grey;" 
			aria-label="Close" 
			(click)="modal.dismiss('Cross click')">
			 
		</button>
	</div>
	<div class="modal-body">
		<app-merchant-documents [isInsideModal]="true"></app-merchant-documents>
	</div>
	<div class="modal-footer d-flex justify-content-between">
		<div></div>
		<button 
			type="button" 
			class="btn btn-sm ml-auto btn-danger" 
			(click)="modal.close('Cross click')">
			{{ 'merchant-info.common.back' | translate }}
			<i class="fa fa-rotate-left mx-1"></i>
		</button>
	</div>
</ng-template>

<!-- Modal for displaying product information -->
<ng-template #content6 let-modal>
	<div class="modal-header d-flex justify-content-between">
		<h6 class="modal-title" style="color: grey;">
			{{ 'merchant-info.modal.productsInfo' | translate }}
		</h6>
		<button 
			type="button" 
			class="close btn-close" 
			style="color: grey;" 
			aria-label="Close" 
			(click)="modal.dismiss('Cross click')">
			 
		</button>
	</div>
	<div class="modal-body">
		<app-products [isInsideModal]="true"></app-products>
	</div>
	<div class="modal-footer d-flex justify-content-between">
		<div></div>
		<button 
			routerLink="/dashboard/merchant-info" 
			type="button" 
			class="btn btn-sm ml-auto btn-danger" 
			(click)="modal.close('Cross click')">
			{{ 'merchant-info.common.back' | translate }}
			<i class="fa fa-rotate-left mx-1"></i>
		</button>
	</div>
</ng-template>

<!-- Modal for displaying company information -->
<ng-template #content7 let-modal>
	<div class="modal-header d-flex justify-content-between">
		<h6 class="modal-title" style="color: grey;">
			{{ 'merchant-info.modal.companiesInfo' | translate }}
		</h6>
		<button 
			type="button" 
			class="close btn-close" 
			style="color: grey;" 
			aria-label="Close" 
			(click)="modal.dismiss('Cross click')">
			 
		</button>
	</div>
	<div class="modal-body">
		<app-company [isInsideModal]="true"></app-company>
	</div>
	<div class="modal-footer d-flex justify-content-between">
		<div></div>
		<button 
			routerLink="/dashboard/merchant-info" 
			type="button" 
			class="btn btn-sm ml-auto btn-danger" 
			(click)="modal.close('Cross click')">
			{{ 'merchant-info.common.back' | translate }}
			<i class="fa fa-rotate-left mx-1"></i>
		</button>
	</div>
</ng-template>

<!-- Customer Account Statement Modal -->
<p-dialog 
	[ngClass]="{'fullscreen-modal': isMobile}"
	[(visible)]="isCustomerAccountStatementModalVisible" 
	[header]="'merchant-info.modal.issuingAccountStatement' | translate" 
	[modal]="true"
	[draggable]="false"
	[resizable]="false"
	[maximizable]="true"
	[breakpoints]="{'768px': '100vw'}">
	<div class="report-modal-toolbar">
		<button
			type="button"
			class="report-back-link report-back-link--button"
			(click)="closeAndReturnToReports()">
			<i class="fa fa-arrow-right" aria-hidden="true"></i>
			{{ 'merchant-info.common.back' | translate }}
		</button>
	</div>
	<form [formGroup]="customerAccountStatementForm">
		<div class="row d-flex justify-content-between">
			<div class="col-md-3 mb-3 mb-lg-0">
				<label for="selectedCustomer" style="color: grey;">
					{{ 'merchant-info.common.customerName' | translate }}
				</label>
				<p-dropdown [options]="customerAccountStatementUserData" optionLabel="customer_display_label" optionValue="user_id"
					dataKey="user_id"
					formControlName="selectedCustomer"
					placeholder="{{ 'merchant-info.common.selectCustomer' | translate }}"
					appendTo="body"
					panelStyleClass="merchant-dd-account-statement-panel"
					scrollHeight="280px"
					[virtualScroll]="false"
					[resetFilterOnHide]="true"
					filter="true"
					filterPlaceholder="{{ 'merchant-info.common.search' | translate }}"
					filterBy="customer_display_label"
					[autoZIndex]="true"
					[baseZIndex]="120000"
					(onChange)="onCustomerChange($event)">
				</p-dropdown>
			</div>
			<div class="col-md-3 mb-3 mb-lg-0">
				<label for="selectedPeriod" style="color: grey;">
					{{ 'merchant-info.common.period' | translate }}
				</label>
				<p-dropdown [options]="periodOptions" formControlName="selectedPeriod" optionLabel="label" optionValue="value"
					(onChange)="filterMonth($event)" appendTo="body">
				</p-dropdown>
			</div>
			<div class="col-md-3 mb-3 mb-lg-0">
				<label for="fromDate" style="color: grey;">
					{{ 'merchant-info.common.fromDate' | translate }}
				</label>
				<div>
					<p-calendar 
						formControlName="startDate" 
						showIcon="true" 
						(dateSelect)="onFromDateChange($event)" 
						(onInput)="onCustomerStatementDateInput($event, 'startDate')"
						(onBlur)="onCustomerStatementDateBlur($event, 'startDate')"
						dateFormat="dd/mm/yy" 
						placeholder="DD/MM/YYYY" 
						[readonlyInput]="false"
						[keepInvalid]="true"
						[maxDate]="getMaxStartDateForModal()"
						appendTo="body">
					</p-calendar>
				</div>
			</div>
			<div class="col-md-3 mb-3 mb-lg-0">
				<label for="toDate" style="color: grey;">
					{{ 'merchant-info.common.toDate' | translate }}
				</label>
				<div>
					<p-calendar 
						formControlName="endDate" 
						showIcon="true" 
						(dateSelect)="onToDateChange($event)" 
						(onInput)="onCustomerStatementDateInput($event, 'endDate')"
						(onBlur)="onCustomerStatementDateBlur($event, 'endDate')"
						dateFormat="dd/mm/yy" 
						placeholder="DD/MM/YYYY" 
						[readonlyInput]="false"
						[keepInvalid]="true"
						[minDate]="getMinEndDateForModal()"
						appendTo="body">
					</p-calendar>
				</div>
			</div>
		</div>
		
		<!-- Date Range Validation Error Message -->
		<div class="row mb-3" *ngIf="modalDateRangeError">
			<div class="col-12">
				<div class="date-validation-error" role="alert">
					<div class="error-content">
						<i class="fa fa-exclamation-circle error-icon"></i>
						<span class="error-text">{{ modalDateRangeError }}</span>
					</div>
				</div>
			</div>
		</div>
		
		<div class="row mt-3">
			<div class="col-12">
				<label style="color: grey; font-weight: bold; margin-bottom: 10px; display: block;">
					{{ 'merchant-info.common.accountTypeLabel' | translate }}
				</label>
				<div class="d-flex flex-column" style="gap: 10px;">
					<div class="form-check">
						<input 
							class="form-check-input" 
							type="radio" 
							name="accountType" 
							id="accountTypeTaxInvoice"
							formControlName="accountType"
							[value]="false">
						<label class="form-check-label" for="accountTypeTaxInvoice" style="color: grey; cursor: pointer;">
							{{ 'merchant-info.common.accountTypeTaxInvoice' | translate }}
						</label>
					</div>
					<div class="form-check">
						<input 
							class="form-check-input" 
							type="radio" 
							name="accountType" 
							id="accountTypeFinancialClaim"
							formControlName="accountType"
							[value]="true">
						<label class="form-check-label" for="accountTypeFinancialClaim" style="color: grey; cursor: pointer;">
							{{ 'merchant-info.common.accountTypeFinancialClaim' | translate }}
						</label>
					</div>
				</div>
			</div>
		</div>
	</form>
	<ng-template pTemplate="footer">
		<div class="report-modal-footer">
			<button 
				pButton 
				label="{{ isPreparingPdf ? ('merchant-info.common.preparingPdf' | translate) : ('merchant-info.common.downloadReports' | translate) }}"
				icon="{{ isPreparingPdf ? 'pi pi-spin pi-spinner' : 'pi pi-download' }}"
				class="p-button-secondary"
				[disabled]="!customerAccountStatementForm.valid || isPreparingPdf || !!modalDateRangeError"
				(click)="CustomerAccountStatementAction()">
			</button>
		</div>
	</ng-template>
</p-dialog>

<!-- Sales Report Modal -->
<p-dialog 
	[ngClass]="{'fullscreen-modal': isMobile}"
	[(visible)]="isSalesReportModalVisible" 
	[header]="'merchant-info.modal.issuingSalesReport' | translate" 
	[modal]="true"
	[draggable]="false"
	[resizable]="false"
	[maximizable]="true"
	[breakpoints]="{'768px': '100vw'}">
	<div class="report-modal-toolbar">
		<button
			type="button"
			class="report-back-link report-back-link--button"
			(click)="closeAndReturnToReports()">
			<i class="fa fa-arrow-right" aria-hidden="true"></i>
			{{ 'merchant-info.common.back' | translate }}
		</button>
	</div>
	<form [formGroup]="salesReportForm">
		<div class="row d-flex justify-content-between">
			<div class="col-md-3 mb-3 mb-lg-0">
				<label for="companyId" style="color: grey;">
					{{ 'merchant-info.common.companyName' | translate }}
				</label>
				<p-dropdown [options]="companyData" optionLabel="company_display_label" optionValue="company_id" formControlName="companyId"
					placeholder="{{ 'merchant-info.common.selectCompany' | translate }}" appendTo="body" filter="true"
					filterPlaceholder="{{ 'merchant-info.common.search' | translate }}">
				</p-dropdown>
				</div>
				<div class="col-md-3 mb-3 mb-lg-0">
				<label for="periodOptions" style="color: grey;">
					{{ 'merchant-info.common.period' | translate }}
				</label>
				<p-dropdown [options]="periodOptions" formControlName="selectedPeriod" optionLabel="label" optionValue="value"
					(onChange)="filterMonth($event)" appendTo="body">
				</p-dropdown>
				</div>
				<div class="col-md-3 mb-3 mb-lg-0">
				<label for="fromDate" style="color: grey;">
					{{ 'merchant-info.common.fromDate' | translate }}
				</label>
				<div>
					<p-calendar formControlName="startDate" showIcon="true" (dateSelect)="onFromDateChange($event)" dateFormat="dd/mm/yy"
						placeholder="DD/MM/YYYY" appendTo="body">
					</p-calendar>
					</div>
					</div>
					<div class="col-md-3 mb-3 mb-lg-0">
				<label for="toDate" style="color: grey;">
					{{ 'merchant-info.common.toDate' | translate }}
				</label>
				<div>
					<p-calendar formControlName="endDate" showIcon="true" (dateSelect)="onToDateChange($event)" dateFormat="dd/mm/yy"
						placeholder="DD/MM/YYYY" appendTo="body">
					</p-calendar>
					</div>
					</div>
					</div>
				</form>
	<ng-template pTemplate="footer">
		<div class="report-modal-footer">
			<button 
				pButton 
				label="{{ 'merchant-info.common.downloadReports' | translate }}" 
				icon="pi pi-download" 
				[disabled]="!salesReportForm.valid" 
				(click)="confirmAction()" 
				class="p-button-secondary">
			</button>
		</div>
	</ng-template>
</p-dialog>

<p-dialog [(visible)]="isConfirmDialogVisible" [header]="'merchant-info.common.reports' | translate" [modal]="true"
	[style]="{width: '50vw'}" [closable]="false"  [draggable]="false">
	<div class="modal-body">
		<p>{{ 'merchant-info.common.pleaseSelectReportFromList' | translate }}</p>
		<div class="content">
			<p 
				style="cursor: pointer;" 
				(click)="openSalesReportModal()">
				<i
					class="pi pi-file-excel mx-1"
					style="color: #141414; font-size: 14px;">
				</i>
				{{ 'merchant-info.common.salesReport' | translate }}
			</p>
			<hr style="color: #141414; border: solid 1px;">
		</div>
		<div class="content">
			<p 
				style="cursor: pointer;" 
				(click)="openCustomerAccountStatementModal()">
				<i
					class="pi pi-file-pdf mx-1"
					style="color: #141414; font-size: 14px;">
				</i>
				{{ 'merchant-info.common.customerAccountStatement' | translate }}
			</p>
			<hr style="color: #141414; border: solid 1px;">
		</div>
		<div class="content">
			<p 
				style="cursor: pointer;" 
				(click)="openCustomerBalancesReport()">
				<i
					class="pi pi-chart-bar mx-1"
					style="color: #141414; font-size: 14px;">
				</i>
				{{ 'merchant-info.common.customerBalancesReport' | translate }}
			</p>
			<hr style="color: #141414; border: solid 1px;">
		</div>
		<div class="content">
			<p 
				style="cursor: pointer;" 
				(click)="openGainLossReport()">
				<i
					class="pi pi-chart-line mx-1"
					style="color: #141414; font-size: 14px;">
				</i>
				{{ 'merchant-info.common.gainLossReport' | translate }}
			</p>
			<hr style="color: #141414; border: solid 1px;">
		</div>
		<div class="content">
			<p 
				style="cursor: pointer;" 
				(click)="openChecksReport()">
				<i
					class="pi pi-money-bill mx-1"
					style="color: #141414; font-size: 14px;">
				</i>
				{{ 'merchant-info.common.checksReport' | translate }}
			</p>
			<hr style="color: #141414; border: solid 1px;">
		</div>
	</div>
	<ng-template pTemplate="footer">
		<p-button (click)="closeConfirmDialog()" label="{{ 'merchant-info.common.close' | translate }}"></p-button>
		<!-- Updated -->
	</ng-template>
</p-dialog>
